// extracted by mini-css-extract-plugin
export var fileUpload = "_ez-1";
export var modalButton = "_ez-0";